/** @format */

import clsx from 'clsx'
import React, {type PropsWithChildren} from 'react'

type SelectionCellProps = PropsWithChildren<{
  className?: string
}>

export function SelectionCell(props: SelectionCellProps) {
  const {children, className} = props
  return (
    <div
      className={clsx(
        'sticky start-0 z-[1] flex flex-none items-center border-e border-gray-100 bg-white p-1.5',
        className,
      )}
    >
      {children}
    </div>
  )
}

type StatusCellProps = PropsWithChildren<{
  className?: string
}>

export function StatusCell(props: StatusCellProps) {
  const {children, className} = props
  return (
    <div
      className={clsx(
        'flex w-8 flex-none items-center justify-center border-e border-gray-100 p-1.5',
        className,
      )}
    >
      {children}
    </div>
  )
}
